import InvoicePreview from './preview.vue';
export default InvoicePreview;
